const cache = new Uint32Array(1);
const maxValue = 4294967295;
const RandomHelper = {
  /**
   * @returns {number} An evenly distributed random number between 0 (inclusive) and 1 (inclusive)
   */
  getValue() {
    window.crypto.getRandomValues(cache);
    return cache[0] / maxValue;
  },
  /**
   * @returns {Uint32Array} An array of evenly distributed random numbers between 0 (inclusive) and 4294967295 (inclusive)
   */
  getValues(count) {
    const result = new Uint32Array(count);
    window.crypto.getRandomValues(result);
    return result;
  },
  getString(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(this.getValue() * (charactersLength - 1))
      );
    }
    return result;
  }
};

export { RandomHelper };
